import api from './api';
import { User, Address, LoyaltyTransaction, ApiResponse } from '../types';

export const userService = {
  getProfile: () => api.get<ApiResponse<User>>('/users/profile'),

  updateProfile: (data: { name?: string; phone?: string }) =>
    api.put<ApiResponse<User>>('/users/profile', data),

  changePassword: (currentPassword: string, newPassword: string) =>
    api.put('/users/change-password', { currentPassword, newPassword }),

  getAddresses: () => api.get<ApiResponse<Address[]>>('/users/addresses'),

  addAddress: (data: Omit<Address, 'id' | 'userId'>) =>
    api.post<ApiResponse<Address>>('/users/addresses', data),

  updateAddress: (id: string, data: Partial<Address>) =>
    api.put<ApiResponse<Address>>(`/users/addresses/${id}`, data),

  deleteAddress: (id: string) => api.delete(`/users/addresses/${id}`),

  getLoyalty: () =>
    api.get<ApiResponse<{ balance: number; transactions: LoyaltyTransaction[] }>>('/users/loyalty'),
};
